export default __webpack_public_path__ + "device_outdoor_cam_plus.852e2273.jpg";